import { BaseStoreNamespace } from 'Redux/Store/BaseStore';
import { FileReference }      from 'Domain/Model/FileReference/FileReference';

interface IFileReferenceState {
  fileReference: {
    entries: Record<string, FileReference>
    maxCount: number;
  },
  searchEntries: Record<string, Record<string, FileReference>>,
  lastInteractiveId: null | string | number,
}

export type TFileReferenceState = IFileReferenceState & BaseStoreNamespace.TDefaultState;


export const FileReferenceState = {
  getInitialState: (): TFileReferenceState => ({
    openRequests     : [],
    failedRequests   : [],
    updatedAt        : 0,
    searchEntries    : {},
    fileReference    : {
      entries : {},
      maxCount: 0,
    },
    lastInteractiveId: null,
  })
};
